module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "ack"
  }, [_c('b', [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("First and foremost to my dear friend Howard Sasportas, who is the father of this child; to Michele Ashmore, who lived through the first trimester with me; to Ean Begg, who conspired with my unconscious and walked with me through a dramatic and highly charged transition; to Melanie Reinhart, for her valued response to the first draft work; to Axel Harvey, for his faith in me and his astute observations and pointed questions on the first draft; to my soul-brother Jim Lewis, who has been with me now for fourteen years sharing dreams, ideas, support, love, black humour and friendship - phone bills from San Francisco to Victoria, then to London notwithstanding! Also to Robertson Davies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my far-flung and highly unconventional family: my brother Rob, for surviving and growing; my stepfather Bob, for standing by me in those times; my Uncle Tom, my surrogate Capricorn mother-father; my Capricorn mother, who died as I began this book; the Capricorn father of my children, Patrick Sullivan; and Kathy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Last but not least to my ever-evolving animus (which, I suspect, is a Capricorn).")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-738ac4a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 72
// module chunks = 0